module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-clientes"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Equipos del cliente " + _vm._s(_vm.cliente.nombre))])]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_vm._v(_vm._s(o.serie))]), _c('td', [_vm._v(_vm._s(o.modelo))]), _c('td', [_vm._v(_vm._s(o.descripcion))]), _c('td', [_vm._v(_vm._s(o.numeroContrato))]), _c('td', [_vm._v(_vm._s(o.descripcionTipoContrato))]), _c('td', [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.remover(o)
        }
      }
    }, [_vm._v("Eliminar")])])])])
  }), 0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Serie")]), _c('th', [_vm._v("Modelo")]), _c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Contrato")]), _c('th', [_vm._v("Tipo de contrato")]), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90000332","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Cliente_Equipo_List.vue
// module id = 520
// module chunks = 1